import { DEFAULT_EIN, EINS, } from "../../types"

const EINReducer = (state = {}, action) => {
    if ([DEFAULT_EIN, EINS].includes(action.type)) {
        return { ...state, [action.type]: action.payload };
    };
    return state;
}

export default EINReducer;